<template>
  <div
    class="presentation text"
    :class="{
      hasOption: question.video || question.audio,
    }"
    :style="{
      justifyContent: pFlexAlign,
      fontFamily: pFont,
      height: textBlockHeight,
    }"
    ref="textWrap"
  >
    <div
      class="text-block"
      style="margin: auto 0; padding: 1em 0"
      :style="{
        fontSize: `${pFontZoom}em`,
        textAlign: pAlign,
      }"
      v-html="presentation.value.split('\n').join('<br>')"
      ref="textBlock"
    ></div>
  </div>

</template>

<script>
/* eslint-disable no-console */
export default {
  props: ["question", "setting", "hasOption"],
  data() {
    return {
      textBlockHeight: "auto",
      blockHeight: "auto",
    };
  },
  computed: {
    presentation() {
      return this.question.presentation;
    },
    pFlexAlign() {
      if (this.presentation.align === "left") {
        return "flex-start";
      }
      return "center";
    },
    pAlign() {
      if (this.presentation.align === "left") {
        return "left";
      }
      return "center";
    },
    pFont() {
      if (this.presentation.font === "none") {
        return "";
      }
      return this.presentation.font;
    },
    pFontZoom() {
      if (!this.presentation.fontZoom) {
        return 1;
      }
      return this.presentation.fontZoom * 1;
    }
  },
  mounted() {
    console.log('textPresentation')
    this.blockInit();
  },
  methods: {
    blockInit() {
      console.log("blockInit");
      this.textBlockHeight = "auto";
      this.$nextTick(() => {
        if (!this.$refs["textBlock"]) {
          this.$emit('blockSize');
          console.log("blockInit")
          return;
        }

        const style = getComputedStyle(this.$refs["textBlock"]);
        const textBlock = this.$refs["textBlock"];
        let optionBlockSize = this.hasOption ? 70 : 0;
        let textBlockHeight;
        if (textBlock.clientHeight >= 300) {
          textBlockHeight = 300;
        } else {
          textBlockHeight = textBlock.clientHeight + 40;
        }
        
        const blockHeight =
          textBlockHeight +
          optionBlockSize +
          parseInt(style.marginTop) +
          parseInt(style.marginBottom);

        this.textBlockHeight = `calc(${textBlockHeight}px + 2em)`;

        this.$emit('blockSize', `calc(${blockHeight}px + 2em)`);
        console.log(this.textBlockHeight);
      });
    }
  }
};
</script>

<style scoped>

.text-block {
  touch-action: pan-y;
  height: 100%;
  max-height: 300px;
}

.hasOption {
  height: calc(100% - 113px);
  max-height: calc(100% - 113px);
}

</style>